/* Newsletter Brand — AJAX-Submit ohne Seiten-Reload.
   Bindet per Delegation an alle .newsletter-brand__form; ersetzt nach dem
   Submit die .newsletter-brand__inner der eigenen Section mit der Antwort
   (Erfolgs-/Fehlerzustand kommt serverseitig gerendert zurück). */

(function () {
  'use strict';

  document.addEventListener('submit', function (event) {
    const form = event.target.closest('.newsletter-brand__form');
    if (!form) return;
    event.preventDefault();

    const section = form.closest('[id^="newsletter-"]');
    if (!section) return;

    const button = form.querySelector('button[type="submit"]');
    if (button) button.disabled = true;

    fetch(form.action, {
      method: 'POST',
      body: new FormData(form),
      headers: { Accept: 'text/html' },
    })
      .then(function (response) {
        return response.text();
      })
      .then(function (html) {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const fresh = doc.getElementById(section.id);
        if (!fresh) return;
        const oldInner = section.querySelector('.newsletter-brand__inner');
        const newInner = fresh.querySelector('.newsletter-brand__inner');
        if (oldInner && newInner) oldInner.replaceWith(newInner);
      })
      .catch(function () {
        if (button) button.disabled = false;
      });
  });
})();
